// Imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { path: '/devices' },
      component: () => import('../layouts/default/Index'),
      children: [
        {
          // Optional company slug (from the company's "Slug" additional info), e.g. /urumpirai/devices
          path: ':slug?/devices',
          name: 'Devices',
          component: () => import('../views/Devices'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'scripts',
          name: 'Scripts',
          component: () => import('../views/CompanyScripts.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'configs',
          name: 'Configs',
          component: () => import('../views/CompanyConfigs.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'kiosk-qr',
          name: 'Kiosk QR',
          component: () => import('../views/KioskQrProvisioning.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'qr-provisioning',
          name: 'QR Provisioning',
          component: () => import('../views/QrProvisioning.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'apps',
          name: 'Apps',
          component: () => import('../views/CompanyApps.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'users',
          name: 'Users',
          component: () => import('../views/Users'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('../views/Settings.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'logs',
          name: 'Logs',
          component: () => import('../views/Logs.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'device-logs',
          name: 'Device logs',
          component: () => import('../views/DeviceLogs.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'remote-assistance/:id',
          name: "Remote Assistance",
          component: () => import('../views/RemoteAssistance.vue'),
        },
        {
          path: 'esp32-ota',
          name: 'ESP32 OTA',
          component: () => import('../views/Esp32Ota.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'mqtt-dashboard',
          name: 'MQTT Dashboard',
          component: () => import('../views/MqttDashboard.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'mqtt-dashboard/:networkId/:vehicleId/:macAddress',
          name: 'MQTT Device Dashboard',
          component: () => import('../views/MqttDeviceDashboard.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'feature-management',
          name: 'Feature Management',
          component: () => import('../views/FeatureManagement.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'device-commands',
          name: 'Device Commands',
          component: () => import('../views/DeviceCommands.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'device-groups',
          name: 'Device Groups',
          component: () => import('../views/DeviceGroups.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'device-groups/:id',
          name: 'Device Group Detail',
          component: () => import('../views/DeviceGroupDetail.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'device-groups/:id/history',
          name: 'Device Group History',
          component: () => import('../views/DeviceGroupHistory.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/login',
      component: () => import('../layouts/page/Index'),
      children: [
        {
          path: '',
          name: 'Login',
          component: () => import('../views/Login'),
        },
      ],
    },
      {
      path: '/qr-provisioning/qr/:id',
      component: () => import('../layouts/page/Index'),
      children: [
        {
          path: '',
          name: 'QrProvisioningQr',
          component: () => import('../views/QrProvisioningQr.vue'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['authUser/isLoggedIn']) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else {
    next()
  }
})

router.afterEach((to) => {
  // Remember the last page visited per user, so a returning user can be sent back to it after login.
  if (to.path === '/login') return
  try {
    const username = store.state.authUser?.username
    if (username) {
      localStorage.setItem(`mydevices:lastRoute:${username}`, to.fullPath)
    }
  } catch (e) {
    // localStorage may be unavailable (e.g. private browsing); ignore.
  }
})

export default router
